var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeasureAppliances(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 76,
    viewBox: "0 0 88 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53,
    cy: 22,
    rx: 16,
    ry: 15,
    fill: "#FFBE36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.506 9.36538C69.1839 17.2074 60.5779 25.3345 53.5459 33.4474C49.145 38.5251 44.5809 43.4985 40.7349 49.0102C37.8435 53.1539 30.7349 59.8913 30.0806 65.2108C29.8164 67.3555 37.004 75.9466 39.3315 74.2147C56.0471 61.7747 66.4903 40.6185 81.4564 26.2743C82.9644 24.8287 87.4639 20.9723 86.8815 18.4997C86.4895 16.8302 78.613 9.54804 76.4977 9.35757C75.9049 9.30302 73.0984 13.1394 72.4432 13.627",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9188 19.2674C80.0571 17.3773 77.311 17.1569 77.0016 18.8925C76.4556 21.946 82.9598 21.9801 82.042 19.0201C81.3608 16.8043 77.1482 17.083 77.3817 19.5902C77.5289 21.1877 81.5604 21.1481 80.9869 19.2907C80.5912 18.0143 77.8653 18.305 79.2288 19.9448C79.8897 20.736 81.8189 20.6147 80.8257 19.8314C79.274 18.605 79.2184 20.3733 79.715 20.2845C80.4991 20.1455 79.8741 19.8621 79.9188 19.2674Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6695 55.1127C36.3356 53.5307 41.3164 59.1427 42.1489 60.1302",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9541 40.2389C49.9916 42.3612 52.9167 44.4975 54.5261 46.2466",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8987 23.799C64.9688 25.982 67.1081 27.7631 68.6577 29.6005",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4822 27.4461C59.7282 26.5499 61.7593 29.4318 62.5913 30.2565",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6421 35.5153C52.8637 34.5899 55.4122 37.4622 55.7897 37.9107",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.66 49.0361C41.0279 48.2838 43.7594 51.5131 43.859 51.6421",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3831 44.0693C46.204 45.5832 46.6706 45.9081 47.5795 47.0932",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3177 21.4345C67.1477 21.276 66.7322 20.7138 66.8794 20.893C67.6708 21.8786 68.4352 22.8861 69.2126 23.8824",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3647 46.4093C-16.4214 25.4021 17.5569 -13.023 44.1524 8.19191C46.2044 9.82622 49.1585 13.1626 49.8259 15.7225C50.1055 16.806 44.0216 22.752 43.4173 22.3998C42.7092 21.9844 43.4173 22.3998 41.1036 18.9957C39.5963 16.778 29.6714 11.7276 22.978 17.4246C20.3122 19.6935 15.8649 24.8263 18.3327 33.0817C18.9204 35.0477 20.3802 36.1473 22.0986 37.6778C22.1932 37.7636 23.244 38.4317 23.1809 38.5401C22.0805 40.4092 14.4451 45.6779 12.3208 46.2332C11.8067 46.3641 11.8788 46.7975 11.3647 46.4093Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46899 36.3759C4.56041 35.667 6.28766 35.5 7.58205 35.1614",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80858 22.0892C1.00129 21.1637 5.22188 22.8014 6.49375 23.289",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0165 8.25912C11.4213 8.13268 14.4881 11.2388 14.9345 11.7896",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0906 3.03992C31.9824 4.62008 31.8562 6.1912 32.0366 7.77138",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9048 12.193L46.6386 12.2652L45.908 13.3127L45.4119 14.1569",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureAppliances);
export default __webpack_public_path__ + "static/media/measure-appliances.b0dcaf50a5232fadddd4da5058244fb7.svg";
export { ForwardRef as ReactComponent };